import * as React from 'react';

import { ITabGroupProps, TabGroup } from '@cian/components';

const styles = require('./pik_tab_group.css');

export class PikTabGroup extends React.PureComponent<ITabGroupProps, object> {
  public render() {
    return (
      <TabGroup
        activeTab={this.props.activeTab}
        containerStyle={[styles['tabs']].concat(this.props.containerStyle)}
        tabStyle={styles['tab']}
        activeTabStyle={styles['active']}
        inactiveTabStyle={styles['inactive']}
        onTabClick={this.props.onTabClick}
        tabs={this.props.tabs}
      />
    );
  }
}
